<template>
  <div
    class="c-content-component"
    v-html="dyanmicCountryString(component.content)"
  />
</template>

<style lang="scss" src="@/assets/sass/components/content-component.scss"></style>

<script>
export default {
  props: {

    // Receive the step and total steps from the parent.
    component: {
      type: Object,
      required: true,
    },
    country: {
      type: String,
      default: 'lungo',
    },
  },
  methods: {
    dyanmicCountryString(text) {
      // set this.countryCapitalised as a computed value.
      let countryCapitalised = this.country.charAt(0).toUpperCase();
      countryCapitalised += this.country.slice(1);

      let otherCountry = '';
      if (countryCapitalised === 'Lungo') {
        otherCountry = 'Oolong';
      } else {
        otherCountry = 'Lungo';
      }
      return text.replace(/COUNTRY/g, countryCapitalised).replace(/OTHER/g, otherCountry);
    },
  },
};
</script>
